import { colors } from '@lamimed/pantheon';

import { ThemeProps } from '.';

export const defaultStyles: ThemeProps = {
  primaryColor: colors.dark,
  textColor: colors.light,
};
